module.exports = __webpack_public_path__ + "static/media/JonathanDonizdeJesus.0d4a11df.jpg";